/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Link_Token_InvalidInputs */

const he_account_delivery_link_token_invalid = /** @type {(inputs: Account_Delivery_Link_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הקישור פג תוקף או לא תקין. נסו שוב.`)
};

const en_account_delivery_link_token_invalid = /** @type {(inputs: Account_Delivery_Link_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has expired or is invalid. Please try again.`)
};

/**
* | output |
* | --- |
* | "This link has expired or is invalid. Please try again." |
*
* @param {Account_Delivery_Link_Token_InvalidInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_link_token_invalid = /** @type {((inputs?: Account_Delivery_Link_Token_InvalidInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Link_Token_InvalidInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_link_token_invalid(inputs)
	return en_account_delivery_link_token_invalid(inputs)
});